import { router } from '@/router'
import store from '@/store'

//路由前置守卫
router.beforeEach(async (to, from, next) => {
  const token = store.getters.access_token
  const roles = store.getters.addRoutes
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else if (!roles || roles.length < 1) {
      await store.dispatch('generateRoutes')
      next({ ...to, replace: true })
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      next()
    }
    next({ path: '/login' })
  }
})
